var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: "Crear Configuración Base" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
            on: { guardar: _vm.handleGuardar },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.configurarCertificado } },
                [
                  _c("ConfigurarCertificadoForm", {
                    on: {
                      change: _vm.handleFormChange,
                      handleFormChange: _vm.handleFormChange,
                      handleLogoTercero: _vm.handleLogoChange
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.editarTexto } },
                [
                  _c("ConfigurarCertificadoFormTexto", {
                    on: {
                      handleTexto: _vm.handleTextoChange,
                      handleFormTextoChange: _vm.handleFormTextoChange
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.gpsVehiculo } },
                [
                  _c("ConfigurarCertificadoFormGps", {
                    on: { handleFormGps: _vm.handleFormGps }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Configuración Base"
          }),
          mensaje: _vm.$t("mensajes.crud.crear.mensaje", {
            entidad: "la Configuración Base"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }